import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const navigateToSection = (sectionId: string) => {
    setMobileMenuOpen(false)
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } })
      return
    }
    const element = document.getElementById(sectionId)
    if (element) window.scrollTo({ top: element.offsetTop - 80, behavior: 'smooth' })
  }

  return (
    <header className="absolute w-full z-30 bg-black/80 backdrop-blur-md border-b border-white/10">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 no-underline">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #e11d48, #f97316)' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="10.5" cy="10.5" r="7"/><line x1="15.5" y1="15.5" x2="21" y2="21" strokeWidth="2.5"/>
                <path d="M6 12.5h9M7.5 12.5l.8-2.5h5.4l.8 2.5" strokeWidth="1.2"/>
                <circle cx="8.5" cy="12.5" r=".8" fill="white" strokeWidth="0"/><circle cx="12.5" cy="12.5" r=".8" fill="white" strokeWidth="0"/>
              </svg>
            </div>
            <span className="font-bold text-lg sm:text-xl text-white">BMWFinder</span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => navigateToSection('features')} className="text-neutral-400 hover:text-white text-sm font-medium bg-transparent border-none cursor-pointer">Features</button>
            <button onClick={() => navigateToSection('faq')} className="text-neutral-400 hover:text-white text-sm font-medium bg-transparent border-none cursor-pointer">FAQ</button>
            <Link to="/browse" className="flex items-center gap-2 bg-rose-600 px-5 py-2.5 rounded-lg text-sm font-medium text-white hover:bg-rose-700 transition-colors">Browse Cars</Link>
          </nav>

          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-neutral-400 hover:text-white bg-transparent border-none" aria-label="Toggle menu">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={mobileMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} /></svg>
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="md:hidden absolute left-4 right-4 bg-[#141414] border border-white/10 rounded-lg p-4 space-y-3">
            <button onClick={() => navigateToSection('features')} className="block w-full text-left px-3 py-2 text-neutral-300 bg-transparent border-none">Features</button>
            <button onClick={() => navigateToSection('faq')} className="block w-full text-left px-3 py-2 text-neutral-300 bg-transparent border-none">FAQ</button>
            <Link to="/browse" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center bg-rose-600 text-white px-5 py-2.5 rounded-lg">Browse Cars</Link>
          </nav>
        )}
      </div>
    </header>
  )
}

export default Header
